/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Lpdealoverviewcontent_Valuerequired5Inputs */

const en_coinvestments_lpdealoverviewcontent_valuerequired5 = /** @type {(inputs: Coinvestments_Lpdealoverviewcontent_Valuerequired5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Value is required`)
};

/**
* | output |
* | --- |
* | "Value is required" |
*
* @param {Coinvestments_Lpdealoverviewcontent_Valuerequired5Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_lpdealoverviewcontent_valuerequired5 = /** @type {((inputs?: Coinvestments_Lpdealoverviewcontent_Valuerequired5Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Lpdealoverviewcontent_Valuerequired5Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_lpdealoverviewcontent_valuerequired5(inputs)
});
export { coinvestments_lpdealoverviewcontent_valuerequired5 as "coInvestments_lpDealOverviewContent_valueRequired" }